export default __webpack_public_path__ + "static/participate2-de0da9d34f40249f842633631f6f94b7.png";